import { getSearchParam } from '@/common/hooks/useSearchParam';
import { trackingIds } from '@/constants/tracking-ids';
import { BrowserPersistence } from '@/util';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const storage = new BrowserPersistence();

export function useFacebookTracking() {
  const searchParams = useSearchParams();

  useEffect(() => {
    // facebook pixel code
    (function (f: Window, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
      if (!(f as any).fbq) {
        n = (f as any).fbq = function (...args: any[]) {
          (n as any).callMethod ? (n as any).callMethod.apply(n, args) : (n as any).queue.push(args);
        };

        if (!(f as any)._fbq) {
          (f as any)._fbq = n;
        }

        (n as any).push = n;
        (n as any).loaded = !0;
        (n as any).version = '2.0';
        (n as any).queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode?.insertBefore(t, s);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    (window as any).fbq('init', trackingIds.facebookId);
    (window as any).fbq('track', 'PageView');
  }, []);

  useEffect(() => {
    // facebook 相关跟踪
    const utm_source = getSearchParam('utm_source', searchParams);

    if (utm_source) {
      storage.setItem('utm_source', utm_source);
    }
  }, [searchParams]);
}
